export default "__VITE_ASSET__DqYEAzGj__"